<template>
    <div class="main">
        <div id="home" v-show="this.$store.state.showHome">
            <img src="http://shared.youdao.com/dict/market/recite-vocabulary/img/top.png" alt="" class="title">
            <img src="http://shared.youdao.com/dict/market/recite-vocabulary/img/data.gif?a=1111" alt="" class="banner">
            <ul class="list">
                <li>小学</li>
                <li>高中</li>
                <li>四级</li>
                <li>六级</li>
                <li>雅思</li>
                <li>词神</li>
            </ul>
            <ul class="avatar">
                <li v-for="(item, index) in headList" :key="index" v-bind:style="{ 'background-image': 'url(' + item.avatar + ')','background-size':'100% 100%' }">
                    <div class="head_img" v-bind:style="{ 'background-image': 'url(' + item.avatar + ')','background-size':'100% 100%' }"></div>
                </li>
                <li class="cover"></li>
            </ul>
            <p>{{peopleNum}}人已测试</p>
            <div class="butten" @click="startTest" data-rlog="start_test">开始测试</div>
            <login-dialog :showLoginDialog="showLoginDialog" @changeShowDialog="changeShowDialog"/>
        </div>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex'
    import loginDialog from './loginDialog'
    import { getNewWordExamUsers, getUserInfo } from './../libs/sever.js'
    import { ydk, isLogin } from './../libs/libs.js'
    export default {
        name: 'Home',
        data () {
            return {
                peopleNum: '',
                headList: '',
                showLoginDialog: false
            }
        },
        computed:{
            ...mapGetters([
                'lastVocabulary',
                'isLogin'
            ])
        },
        watch: {
            lastVocabulary: function(val) { 
                this.showLoginDialog = false
            }
        },
        created () {
            let that = this
            getNewWordExamUsers(9).then(function (res) {
                that.headList = res.data.data.result.wordExamNewUsers
                that.peopleNum = res.data.data.result.wordExamUsersNum
            })
        },
        methods: {
            startTest: function () {
                let that = this
                ydk.isLogin({
                    success: function (res) {
                        if (res.isLogin) {
                            that.$store.commit('HIDEHOME')
                            that.$store.commit('ISLOGIN', true)
                            getUserInfo().then((res) => {
                                that.$store.commit('USERNAME', res.data.data.userInfo.nick)
                            })
                        } else {
                            that.showLoginDialog = true
                        }
                    }
                })
            },
            changeShowDialog: function (val) {
                this.showLoginDialog = val
                this.$store.commit('HIDEHOME')
            }
        },
        components: {
            loginDialog
        }
        
    }
</script>

<style>
    #home {
        width: 100%;
        height: 100%;
        overflow: hidden;
        position: relative;
    }
    #home .title {
        width: 66%;
        margin: 0.66rem auto 0;
    }
    #home .banner {
        width: 100%;
        margin: 0 auto 0.31rem;
    }
    #home p {
        width: 100%;
        height: 0.37rem;
        font-size: 0.26rem;
        text-align: center;
        font-family:PingFangSC-Regular;
        color:rgba(72,78,94,1);
        line-height: 0.37rem;
        margin: 0.1rem 0 0.38rem 0 ;
    }
    #home .butten {
        width: 5.83rem;
        height: 0.89rem;
        border-radius: 1rem;
        text-align: center;
        font-size: 0.32rem;
        color: rgba(255,255,255,1);
        line-height: 0.89rem;
        margin: 0 auto 1rem;
        font-weight: 600;
        background:linear-gradient(135.4deg,rgba(255,175,36,1),rgba(255,138,38,1),rgba(255,135,38,1),rgba(255,135,38,1));
        box-shadow: 0 0.04rem 0.11rem 0 rgba(254,187,97,0.36);
    }
    #home .avatar {
        height: 0.61rem;
        width: 4.56rem;
        overflow: hidden;
        margin: 0 auto;
        position: relative;
    }
    #home .list {
        height: 0.4rem;
        width: 5.98rem;
        overflow: hidden;
        margin: 0 auto 0.84rem;
    }
    #home .list li{
        overflow: hidden;
        height: 0.4rem;
        float: left;
        overflow: hidden;
        font-size: 0.28rem;
        font-family: PingFangSC-Regular;
        color: rgba(144,148,158,1);
        line-height: 0.4rem;
        margin-left: 0.52rem;
        position: relative;
    }
    #home .list li:first-child {
        margin-left: 0;
    }
    #home .avatar li{
        width: 0.53rem;
        height: 0.53rem;
        margin:  0.04rem 0.1rem 0.04rem 0;
        float: left;
        border-radius: 50%;
        position: relative;
    }
    .main #home .avatar .cover {
        width: 4.56rem;
        position: absolute;
        height: 0.53rem;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        border-radius: 0%;
        background: linear-gradient( 
            to right, 
            rgba(255,255,255,1) 0%, 
            rgba(255,255,255,0.2) 40%, 
            rgba(255,255,255,0) 50%,
            rgba(255,255,255,0.2) 60%, 
            rgba(255,255,255,1) 100%) 
    }
    .head_img {
        width: 0.53rem;
        height: 0.53rem;
        float: left;
        border-radius: 50%;
    }
    #home .avatar li:last-child {
        margin-right:  0;
    }
</style>



// WEBPACK FOOTER //
// src/components/Home.vue